import { PagesAdmin } from './PagesAdmin';

export function PostsAdmin({ csrfToken }: { csrfToken: string }) {
  return <PagesAdmin csrfToken={csrfToken} kind="post" />;
}
